module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "responsive",
      rawName: "v-responsive",
      value: (_vm.contactRowSizes),
      expression: "contactRowSizes"
    }],
    staticClass: "contact-row"
  }, [_c('img', {
    staticClass: "contact-image round white-border shadow mr-2",
    attrs: {
      "src": _vm.contact.image,
      "alt": _vm.contact.firstName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-details"
  }, [_c('div', [_vm._v(_vm._s(_vm.contact.firstName) + " " + _vm._s(_vm.contact.lastName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.contact.mobile))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f650cc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/contacts/ContactRow.vue
// module id = 2623
// module chunks = 1